import { defineComponent as _defineComponent } from 'vue'
import gBaseModal from '@/components/g-base-modal.vue'
import { translateLang } from '@/data/i18n/translateLang'
import { copyText } from '@/util/common'

interface PreviewData {
  name: string
  expire_time: string
  key: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-preview-modal',
  props: {
    visible: { type: Boolean },
    data: null
  },
  emits: ["cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  data: PreviewData
}





function handleCopyKey() {
  copyText(props.data.key)
}

return { __sfc: true,props, emit, handleCopyKey, gBaseModal, translateLang }
}

})